module.exports = __webpack_public_path__ + "static/media/8.7d1df930.jpg";